<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title" style="font-size: 16px; font-weight: bold;">设备品牌</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input v-model="value" placeholder="根据品牌名称搜索" @on-enter="getData" style="width: 250px">
          <Button slot="append" icon="ios-search" @click="getData"></Button>
        </Input>
        <Button style="margin: 2px 0 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Button type="primary" @click="current = {};visible = true">新增设备品牌</Button>
      </div>
    </div>
    <Table style="margin:auto" :columns="columns" :data="filteredData"/>
    <Modal v-model="visible" :title="current.id?'修改设备品牌':'新增设备品牌'" @on-cancel="visible = false">
      <Form ref="formInline" :model="current" :rules="rule" :label-width="80">
        <FormItem prop="name" label="名称:">
          <Input v-model="current.name" placeholder="品牌名称"/>
        </FormItem>
        <FormItem prop="sort" label="排序权重:">
          <InputNumber v-model="current.sort" :min="0" style="width: 100%" placeholder="数字越大越靠前, 默认为0"></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="visible = false;">取消</Button>
        <Button type="primary" @click="modalOk" :loading="modalLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      rule: {
        name: [{ required: true, message: '品牌名称必填', trigger: 'blur' }]
      },
      columns: [
        { title: '编号', width: 100, key: 'id' },
        { title: '名称', key: 'name' },
        { title: '排序权重', key: 'sort', render: (h, params) => h('span', params.row.sort || 0) },
        { title: '操作',
          width: 150,
          key: 'operator',
          render: (h, data) => {
            return h('div', {}, [
              h('Button', { props: { size: 'small', type: 'warning' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.current = JSON.parse(JSON.stringify(data.row))
                    if (this.current.sort === undefined || this.current.sort === null) {
                      this.current.sort = 0
                    }
                    this.visible = true
                  }
                } }, '修改'),
              h('Button', { props: { size: 'small', type: 'error' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除',
                      content: `是否确定要删除该设备品牌(${data.row.name})?`,
                      closable: true,
                      loading: true,
                      onOk: () => {
                        this.deleteBrand(data.row.id)
                      }
                    })
                  }
                } }, '删除')
            ])
          } }
      ],
      data: [],
      current: { sort: 0 },
      visible: false,
      modalLoading: false,
      value: ''
    }
  },
  computed: {
    filteredData () {
      if (!this.value) {
        return this.data
      }
      return this.data.filter(item => item.name && item.name.includes(this.value))
    }
  },
  methods: {
    reset () {
      this.value = ''
      this.getData()
    },
    deleteBrand (id) {
      this.delBrand({ id }).then(res => {
        this.$Modal.remove()
        if (res && res.status === true) {
          this.$Message.success('删除成功')
          this.getData()
        } else if (res && res.status === false) {
          this.$Message.error(res.msg || '已有设备关联该品牌，不允许删除')
        } else {
          this.$Message.error('删除失败')
        }
      }).catch(err => {
        this.$Modal.remove()
        console.error('删除失败', err)
        this.$Message.error('删除失败')
      })
    },
    modalOk () {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          this.modalLoading = true
          const submitData = {
            name: this.current.name,
            sort: this.current.sort || 0
          }
          if (this.current.id) {
            submitData.id = this.current.id
          }

          this.insertBrand(submitData).then(res => {
            this.modalLoading = false
            if (res && res.status === false) {
              this.$Message.error(res.msg || '保存失败，请重试')
            } else {
              this.$Message.success('操作成功')
              this.visible = false
              this.getData()
            }
          }).catch(err => {
            this.modalLoading = false
            console.error('保存失败', err)
            this.$Message.error('保存失败')
          })
        }
      })
    },
    getData () {
      this.getBrand().then(res => {
        this.data = Array.isArray(res) ? res : (res && Array.isArray(res.data) ? res.data : [])
        // Sort by 'sort' descending, then 'id' descending
        this.data.sort((a, b) => {
          let sortA = a.sort || 0
          let sortB = b.sort || 0
          if (sortA !== sortB) {
            return sortB - sortA
          }
          return (b.id || 0) - (a.id || 0)
        })
      })
    },
    ...mapActions(['getBrand', 'insertBrand', 'delBrand'])
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
